module.exports = __webpack_public_path__ + "img/warming.918b0e34.918b0e34.png";